module.exports = __webpack_public_path__ + "img/5_sp.0c5cb9ae.gif";